import React from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import {
	Box,
	Button,
	Grid,
	IconButton,
	Menu,
	MenuItem,
	Typography,
} from '@mui/material';

import AddIcon from '@mui/icons-material/Add';

import bundleImg from '../../../../assets/logos/bundlesimg.png';

import MoreVertIcon from '@mui/icons-material/MoreVert';

// const options = ['Edit', 'Delete'];

const bundleData = [
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	{ hospitalName: 'Central Hospital USA', charges: 20 },
	// Add data for other bundles as needed
];

function Bundles() {
	const defaultTheme = createTheme();

	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid container xs={12} sm={12} md={12}>
				{/* <Grid
					item
					xs={12}
					sm={12}
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						borderBottom: ' 1px solid #00000026',
						padding: '10px 5px',
					}}
				>
					<Typography
						variant="body1"
						sx={{
							fontFamily: 'Poppins',
							fontSize: '20px',
							fontWeight: '500',
							textAlign: 'left',
							color: 'black',
						}}
					>
						Bundles
					</Typography>
					<Button
						variant="contained"
						startIcon={<AddIcon />}
						sx={{
							fontFamily: 'Poppins',
							fontSize: '14px',
							fontWeight: '500',
							lineHeight: '21px',
							background: '#FD7702',
							'&:hover': {
								border: '#FD7702',
								color: '#FD7702',
								background: 'white',
							},
						}}
					>
						Create Bundle
					</Button>
				</Grid> */}
				<Box
					sx={{
						overflowY: 'auto',
						height: {
							lg: '460px',
							sm: '440px',
							md: '450px',
							xs: '430px',
							xl: '550px',
						},
						'@media only screen and (max-width: 1920px) and (min-width: 1760px)':
							{
								// Styles for xs and sm screens
								height: '650px',
							},
					}}
				>
					<Grid
						item
						container
						xs={12}
						sx={{
							padding: '25px 15px',
						}}
					>
						{bundleData.map((bundle, index) => (
							<Grid
								item
								xs={12}
								lg={3}
								xl={3}
								md={4.5}
								sm={4.5}
								key={index}
								sx={{ margin: '30px' }}
							>
								<Box
									sx={{
										borderRadius: '8px',
										boxShadow: '0px 1px 4px 0px #00000040',
										padding: '5px',
										position: 'relative',
										textAlign: 'center',
									}}
								>
									<img
										src={bundleImg}
										alt={`Bundle Image ${index}`}
										style={{
											position: 'absolute',
											top: '-20px',
											right: '40%',
										}}
									/>

									<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
										<IconButton
											aria-label="more"
											id={`long-button-${index}`}
											aria-expanded={anchorEl ? 'true' : undefined}
											aria-haspopup="true"
											onClick={handleClick}
										>
											<MoreVertIcon />
										</IconButton>
										<Menu
											id={`long-menu-${index}`}
											MenuListProps={{
												'aria-labelledby': `long-button-${index}`,
											}}
											anchorEl={anchorEl}
											open={Boolean(anchorEl)}
											onClose={handleClose}
											PaperProps={{
												elevation: 0,
												style: {
													boxShadow: '0px 1px 1px 0px #00000040',
													borderRadius: '10px',
												},
											}}
										>
											{/* Add menu options if needed */}
											<MenuItem
												selected={false}
												style={{
													color: 'black',
													fontFamily: 'Poppins',
													fontSize: '13px',
												}}
												onClick={handleClose}
											>
												Edit
											</MenuItem>
											<MenuItem
												selected={false}
												style={{
													color: '#ED2828',
													fontFamily: 'Poppins',
													fontSize: '13px',
												}}
												onClick={handleClose}
											>
												Delete
											</MenuItem>
										</Menu>
									</Box>
									<Typography
										variant="body2"
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '400',
											lineHeight: '21px',
										}}
									>
										{bundle.hospitalName}
									</Typography>
									<Typography
										variant="body2"
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '400',
											lineHeight: '21px',
										}}
									>
										Charges: {bundle.charges}
									</Typography>
								</Box>
							</Grid>
						))}
					</Grid>
				</Box>
			</Grid>
		</ThemeProvider>
	);
}

export default Bundles;
